import React, {useEffect, useState} from "react";
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Divider from '@mui/joy/Divider';
import { NumericFormat } from 'react-number-format';
import {useNavigate} from "react-router-dom"
import Swal from "sweetalert2";
import axios from 'axios'
import moment from 'moment';
import ExchangeOperationService from "../../../services/exchangeOperationService";

// ESTE ES EL MODAL DE DETALLE DE OPERACIONES DE BALACNE EN USD
function ModalBalanceOperations( {handleOpen, isOpen, title, portfolioManager, arrayOperations} ) {

    let sumMoney = 0
    let sumQty = 0
    let sumAjuste = 0

    const navigate = useNavigate();
    const userProfile = JSON.parse(sessionStorage.getItem("userProfile"));
    const [cargando, setCargando] = useState(true)
    const [listOperations, setListOperations] = useState([]);

    useEffect(() => {
        if(arrayOperations !== ''){
            setCargando(true)
            ExchangeOperationService.getIntermOperationByIds(arrayOperations)
                .then((response) => {
                    setListOperations(response.data)
                })
                .catch((error) => {
                    Swal.fire({
                        title: 'ERROR',
                        text: error[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                })
                .finally(() => { setCargando(false) })
        }
    }, [arrayOperations])

    const doDownload =  async () => {
        try {
            if(arrayOperations !== ''){
                window.open(process.env.REACT_APP_API_URL+"exchange-operations/download/excel/revenue?token="+userProfile.token+'&ids='+arrayOperations, '_blank')
            }
        } catch (e) {
            if (axios.isAxiosError(e)) {
                const statusCode = e.response?.status
                const error = e.response?.data.errors;
                if(statusCode && statusCode !== 401){
                    Swal.fire({
                        title: 'ERROR',
                        text: error[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                }else{
                    sessionStorage.removeItem("userProfile");
                    navigate('/')
                    window.location.reload();
                }
            }
        } 
    }

    return (
        <Modal
            aria-labelledby="close-modal-title"
            open={isOpen}
            onClose={() => handleOpen(false) }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <ModalDialog>
                <ModalClose variant="outlined" />
                <DialogTitle>{title}</DialogTitle>
                <Divider />
                <DialogContent>
                    {cargando ?
                    <>
                        <div className="row">   
                            <div className="col-12 d-grid gap-2 d-md-flex justify-content-md-center">
                                <div className="d-flex justify-content-center">
                                    <div className="spinner-border text-info" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                    :
                    <>
                    <table className="table table-sm table-hover dataTable dtr-column" >
                        <thead style={{backgroundColor: '#FFFFFF'}}>
                            <tr className="text-nowrap">
                                <th>#</th>
                                <th>Fecha</th>
                                <th>Comintente</th>
                                <th>Tipo</th>
                                <th>Segmento</th>
                                <th>Tipo Operación</th>
                                <th>Cantidad</th>
                                <th>Precio Base</th>
                                <th>Precio Esco</th>
                                <th className="text-end">AR$</th>
                                <th>Comercial</th>
                                <th>Contraparte</th>
                            </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                            {listOperations.map((operation, index) => {
                                if (operation.account_model.is_internal) {
                                    // COMITENTE ES INTERNO
                                    // COMPRA CABLE (1) y COMPRA MEP (3) - VTA CABLE (2) y VTA MEP (4)
                                    if(operation.counterparty_id === 1) {
                                        // CONTRAPARTE ES MERCADO
                                        if(operation.currency_exchange_type.id === 1 || operation.currency_exchange_type.id === 3) {
                                            sumMoney = sumMoney + parseFloat(operation.price * operation.qty)
                                            sumQty = sumQty +  parseFloat(operation.qty)
                                            sumAjuste = sumAjuste - parseFloat(operation.price * operation.qty);
                                        }else if(operation.currency_exchange_type.id === 2 || operation.currency_exchange_type.id === 4) {
                                            sumMoney = sumMoney -  parseFloat(operation.price * operation.qty)
                                            sumQty = sumQty -  parseFloat(operation.qty)
                                            sumAjuste = sumAjuste + parseFloat(operation.price * operation.qty);
                                        }
                                    }else{
                                        if(operation.portfolio_manager.id === portfolioManager.id){
                                            if(operation.currency_exchange_type.id === 1 || operation.currency_exchange_type.id === 3) {
                                                sumMoney = sumMoney + parseFloat(operation.price * operation.qty)
                                                sumQty = sumQty +  parseFloat(operation.qty)
                                                sumAjuste = sumAjuste - parseFloat(operation.price * operation.qty);
                                            }else if(operation.currency_exchange_type.id === 2 || operation.currency_exchange_type.id === 4) {
                                                sumMoney = sumMoney -  parseFloat(operation.price * operation.qty)
                                                sumQty = sumQty -  parseFloat(operation.qty)
                                                sumAjuste = sumAjuste + parseFloat(operation.price * operation.qty);
                                            }
                                        }else{
                                            if(operation.currency_exchange_type.id === 1 || operation.currency_exchange_type.id === 3) {
                                                sumMoney = sumMoney - parseFloat(operation.price * operation.qty)
                                                sumQty = sumQty -parseFloat(operation.qty)
                                                sumAjuste = sumAjuste + parseFloat(operation.price * operation.qty);
                                            }else if(operation.currency_exchange_type.id === 2 || operation.currency_exchange_type.id === 4) {
                                                sumMoney = sumMoney +  parseFloat(operation.price * operation.qty)
                                                sumQty = sumQty + parseFloat(operation.qty)
                                                sumAjuste = sumAjuste - parseFloat(operation.price * operation.qty);
                                            }
                                        }
                                    }
                                }else{
                                    // COMPRA CABLE (1) y COMPRA MEP (3) - VTA CABLE (2) y VTA MEP (4)
                                    if(operation.currency_exchange_type.id === 1 || operation.currency_exchange_type.id === 3) {
                                        sumMoney = sumMoney - parseFloat(operation.price * operation.qty)
                                        sumQty = sumQty -  parseFloat(operation.qty)
                                        sumAjuste = sumAjuste + parseFloat(operation.price * operation.qty);
                                    }else if(operation.currency_exchange_type.id === 2 || operation.currency_exchange_type.id === 4) {
                                        sumMoney = sumMoney +  parseFloat(operation.price * operation.qty)
                                        sumQty = sumQty +  parseFloat(operation.qty)
                                        sumAjuste = sumAjuste - parseFloat(operation.price * operation.qty);
                                    }
                                }
                                return (
                                    <tr key={operation.id}>  
                                        <td>{operation.id}</td>
                                        <td>{moment(operation.date).format('DD/MM/YYYY')}</td>
                                        <td>
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    <a className="text-body text-truncate">
                                                        <span className="fw-medium">
                                                            {operation.account_model.name.length > 30 ?
                                                                `${operation.account_model.name.substring(0, 30)}...` : operation.account_model.name
                                                            }
                                                        </span>
                                                    </a>
                                                    <small className="text-muted"><span className="badge bg-label-dark">{operation.account_model.account}</span></small>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    {operation.exchange_type_id === 1 ?
                                                        <small className="text-muted"><span className="badge bg-label-primary me-1">{operation.currency_exchange_type.name}</span></small>
                                                    :
                                                        <small className="text-muted"><span className="badge bg-label-dark">x Instrumento AA</span></small>
                                                    }
                                                </div>
                                            </div>                                            
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    <small className="text-muted">
                                                        {operation.segment_id === 1 && <span className="badge bg-label-primary me-1">{operation.segment.name}</span>}
                                                        {operation.segment_id === 2 && <span className="badge bg-label-info me-1">{operation.segment.name}</span>}
                                                        {operation.segment_id === 3 && <span className="badge bg-label-secondary me-1">{operation.segment.name}</span>}
                                                    </small>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    <a className="text-body text-truncate">
                                                        <span className="fw-medium">
                                                            {operation.operation_type_id === 1 && <span className="badge bg-label-success me-1">{operation.operation_type.name}</span>}
                                                            {operation.operation_type_id === 2 && <span className="badge bg-label-danger me-1">{operation.operation_type.name}</span>}
                                                        </span>
                                                    </a>
                                                    <small className="text-muted">
                                                        <span className="badge bg-label-dark">{operation.settlement_term.name}</span>
                                                        <span className="badge bg-label-dark">{operation.ticker}</span>
                                                    </small>
                                                    <small className="text-muted"></small>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="text-end">
                                            <NumericFormat 
                                                displayType="text" 
                                                value={operation.qty} 
                                                allowLeadingZeros thousandSeparator="." 
                                                decimalSeparator="," 
                                            /> 
                                        </td>
                                        <td className="text-end">
                                            <NumericFormat 
                                                displayType="text" 
                                                value={operation.price} 
                                                decimalScale={4} 
                                                allowLeadingZeros thousandSeparator="." 
                                                decimalSeparator="," 
                                                prefix={'$'}  
                                            /> 
                                        </td>
                                        <td className="text-end">
                                            <NumericFormat 
                                                displayType="text" 
                                                value={operation.esco_price} 
                                                decimalScale={4} 
                                                allowLeadingZeros thousandSeparator="." 
                                                decimalSeparator="," 
                                                prefix={'$'}  
                                            /> 
                                        </td>
                                        <td className="text-end">
                                            <NumericFormat 
                                                displayType="text" 
                                                value={operation.price * operation.qty} 
                                                allowLeadingZeros thousandSeparator="." 
                                                decimalSeparator=","
                                                prefix={'$'}  
                                                decimalScale={2} 
                                            /> 
                                        </td>                                    
                                        <td>{operation.portfolio_manager.name}</td>
                                        <td>{operation.counterparty.name}</td>
                                    </tr>
                                    )
                                })
                            }
                        </tbody>
                        {/* FOOTER */}
                        <tfoot>
                            <tr  style={{backgroundColor: "#F2F2F2", fontWeight: "bold"}}>
                                <td colSpan="6" className="text-end">  Promedio:  </td>
                                <td className="text-end">
                                    <NumericFormat 
                                        displayType="text" 
                                        value={sumQty}
                                        decimalScale={2}      
                                        allowLeadingZeros thousandSeparator="." 
                                        decimalSeparator="," 
                                    /> 
                                </td>
                                <td className="text-end">
                                    <NumericFormat 
                                        displayType="text" 
                                        value={sumMoney / sumQty} 
                                        decimalScale={2} 
                                        allowLeadingZeros thousandSeparator="." 
                                        decimalSeparator="," 
                                        prefix={'$'}  
                                    /> 
                                </td>
                                <td colSpan="1" className="text-end">Ajuste: </td>
                                <td className="text-end">
                                    <NumericFormat 
                                        displayType="text"   
                                        value={sumAjuste}
                                        decimalScale={2}      
                                        allowLeadingZeros thousandSeparator="." 
                                        decimalSeparator="," 
                                        prefix={'$'}  
                                    /> 
                                </td>
                                <td colSpan="2"></td>
                            </tr>
                        </tfoot>
                    </table>
                    </>
                    }
                </DialogContent>
                <Divider />
                <DialogActions>
                    <button type="button" className="btn btn-info" onClick={() => doDownload()}> <i className="bx bx-cloud-download"></i> Descargar </button>                                                         
                </DialogActions> 
            </ModalDialog>
        </Modal>

    );
}

export default ModalBalanceOperations;